import React__default, { memo, useState } from 'react';
import { useBoolean } from '@sravni/react-utils';
import 'classnames';
import '@sravni/react-design-system';
import '../../PopupForSpecialOffers/src/PopupForSpecialOffers.module.scss.js';
import { PopupForSpecialOffersWithAuthorization } from '../../PopupForSpecialOffers/src/PopupForSpecialOffersWithAuthorization.js';
import { withIdleWrapper } from '../../WithIdleWrapper/src/WithIdleWrapper.js';
import { SpecialOffersContent } from './components/SpecialOffersContent.js';

const SpecialOffersPopupIdle = withIdleWrapper(PopupForSpecialOffersWithAuthorization);
const IdleSpecialOffersPopup = memo(({ isUserLogged, ...props }) => {
    const [wasShown, setWasShown] = useBoolean();
    const [isContentLoaded, setContentLoaded] = useState(false);
    const [activeTab, setActiveTab] = useState();
    if (isUserLogged)
        return null;
    return (React__default.createElement(SpecialOffersPopupIdle, { wasShown: wasShown, onClose: setWasShown.on, isContentLoaded: isContentLoaded, activeTab: activeTab, pushEvent: props.pushEvent },
        React__default.createElement(SpecialOffersContent, { setContentLoaded: setContentLoaded, setActiveTab: setActiveTab, ...props })));
});

export { IdleSpecialOffersPopup };
//# sourceMappingURL=IdleSpecialOffersPopup.js.map
